export * from './MultipleImageComponent';
